import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { login as _login, getInfo as _getInfo, logout as logoutApi } from '@/api/sys/auth';
import { getToken, getRefreshToken, setToken, setRefreshToken, removeToken, setRememberMe, getRememberMe } from '@/utils/auth';
import { resetRouter } from '@/router';
import { AESEncrypt } from '@/utils/util';
import signalRService from '@/utils/signalr';
import { getUserAllSchools } from '@/api/sys/userSchool';
var state = {
  userId: null,
  token: getToken(),
  refreshToken: getRefreshToken(),
  name: '',
  avatar: '',
  roles: [],
  info: {},
  // 多学校相关状态
  currentSchoolId: null,
  userSchools: [],
  primarySchool: null,
  // 在线用户相关状态
  onlineUsers: [],
  onlineUserCount: 0
};
var mutations = {
  SET_USERID: function SET_USERID(state, id) {
    state.userId = id;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_REFRESH_TOKEN: function SET_REFRESH_TOKEN(state, token) {
    state.refreshToken = token;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_USER: function SET_USER(state, user) {
    state.info = user;
  },
  // 多学校相关mutations
  SET_CURRENT_SCHOOL: function SET_CURRENT_SCHOOL(state, schoolId) {
    state.currentSchoolId = schoolId;
  },
  SET_USER_SCHOOLS: function SET_USER_SCHOOLS(state, schools) {
    state.userSchools = schools;
    // 设置默认当前学校
    if (schools && schools.length > 0 && !state.currentSchoolId) {
      // 优先选择主学校
      var primarySchool = schools.find(function (s) {
        return s.id === state.info.schoolId;
      });
      state.currentSchoolId = primarySchool ? primarySchool.id : schools[0].id;
    }
  },
  SET_PRIMARY_SCHOOL: function SET_PRIMARY_SCHOOL(state, school) {
    state.primarySchool = school;
  },
  // 在线用户相关mutations
  SET_ONLINE_USERS: function SET_ONLINE_USERS(state, users) {
    state.onlineUsers = users || [];
    state.onlineUserCount = users ? users.length : 0;
  },
  UPDATE_ONLINE_USERS: function UPDATE_ONLINE_USERS(state, _ref) {
    var userList = _ref.userList;
    state.onlineUsers = userList || [];
    state.onlineUserCount = userList ? userList.length : 0;
  }
};
var actions = {
  // user login
  login: function login(_ref2, userInfo) {
    var commit = _ref2.commit;
    var user = JSON.parse(JSON.stringify(userInfo));
    var rememberMe = user.rememberMe || false;
    delete user.rememberMe; // 不发送到后端

    user.password = AESEncrypt(user.password, 'valid.jqinfo.top');
    return new Promise(function (resolve, reject) {
      _login(user).then(function (response) {
        var _response$data = response.data,
          accessToken = _response$data.accessToken,
          refreshToken = _response$data.refreshToken;
        commit('SET_TOKEN', accessToken);
        commit('SET_REFRESH_TOKEN', refreshToken);
        setRememberMe(rememberMe); // 保存记住状态
        setToken(accessToken); // access token 仅保存到当前会话
        setRefreshToken(refreshToken, rememberMe);
        signalRService.init(accessToken);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user login
  qrLogin: function qrLogin(_ref3, token) {
    var commit = _ref3.commit;
    return new Promise(function (resolve, reject) {
      commit('SET_TOKEN', token);
      commit('SET_REFRESH_TOKEN', '');
      setToken(token);
      setRefreshToken('');
      signalRService.init(token);
      resolve();
    });
  },
  // get user info
  getInfo: function getInfo(_ref4) {
    var commit = _ref4.commit,
      dispatch = _ref4.dispatch;
    return new Promise(function (resolve, reject) {
      _getInfo().then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var id = data.id,
          name = data.name,
          avatar = data.avatar,
          roles = data.roles;
        commit('SET_USERID', id);
        commit('SET_NAME', name);
        commit('SET_AVATAR', avatar);
        dispatch('settings/loadUserPreferences', id, {
          root: true
        });
        if (roles && roles.length > 0) {
          commit('SET_ROLES', roles);
        } else {
          commit('SET_ROLES', ['ROLE_DEFAULT']);
        }
        commit('SET_USER', data);

        // 如果用户有多学校关联，加载学校信息
        if (data.schools && data.schools.length > 0) {
          commit('SET_USER_SCHOOLS', data.schools);
          var primarySchool = data.schools.find(function (s) {
            return s.id === data.schoolId;
          });
          if (primarySchool) {
            commit('SET_PRIMARY_SCHOOL', primarySchool);
          }
        }
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state,
      dispatch = _ref5.dispatch;
    return new Promise(function (resolve, reject) {
      var currentToken = state.token;
      var clearClientState = function clearClientState() {
        commit('SET_TOKEN', '');
        commit('SET_REFRESH_TOKEN', '');
        commit('SET_USERID', null);
        removeToken();
        resetRouter();
        signalRService.stop();
        dispatch('settings/resetUserPreferences', null, {
          root: true
        });
        resolve();
      };
      if (!currentToken) {
        clearClientState();
        return;
      }
      logoutApi(currentToken).catch(function () {
        // 后端登出失败时仍然清理本地状态，避免页面卡死。
      }).finally(function () {
        clearClientState();
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref6) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_REFRESH_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_USERID', null);
      dispatch('settings/resetUserPreferences', null, {
        root: true
      });
      removeToken();
      resolve();
    });
  },
  updateTokens: function updateTokens(_ref7, _ref8) {
    var commit = _ref7.commit;
    var accessToken = _ref8.accessToken,
      refreshToken = _ref8.refreshToken;
    return new Promise(function (resolve) {
      var rememberMe = getRememberMe();
      commit('SET_TOKEN', accessToken);
      commit('SET_REFRESH_TOKEN', refreshToken);
      setToken(accessToken);
      setRefreshToken(refreshToken, rememberMe);
      resolve();
    });
  },
  // 切换当前学校
  switchSchool: function switchSchool(_ref9, schoolId) {
    var commit = _ref9.commit;
    commit('SET_CURRENT_SCHOOL', schoolId);
  },
  // 加载用户学校信息
  loadUserSchools: function loadUserSchools(_ref0) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var commit, state, response, schools, primarySchool, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref0.commit, state = _ref0.state;
            if (state.userId) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            _context.p = 1;
            _context.n = 2;
            return getUserAllSchools(state.userId);
          case 2:
            response = _context.v;
            schools = response.data || [];
            commit('SET_USER_SCHOOLS', schools);

            // 设置主学校
            primarySchool = schools.find(function (s) {
              return s.id === state.info.schoolId;
            });
            if (primarySchool) {
              commit('SET_PRIMARY_SCHOOL', primarySchool);
            }
            return _context.a(2, schools);
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error('加载用户学校信息失败:', _t);
            return _context.a(2, []);
        }
      }, _callee, null, [[1, 3]]);
    }))();
  },
  // 更新在线用户列表
  updateOnlineUsers: function updateOnlineUsers(_ref1, _ref10) {
    var commit = _ref1.commit;
    var realName = _ref10.realName,
      online = _ref10.online,
      userList = _ref10.userList;
    commit('UPDATE_ONLINE_USERS', {
      userList: userList
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};